var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartups(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 10.7947C10.784 0.946558 17.3635 0.832998 19.9928 2.00724C21.167 4.6365 21.0534 11.216 11.2053 16.5C11.1031 15.9129 10.5352 14.3749 9.0801 12.9199C7.62512 11.4648 6.08712 10.8969 5.5 10.7947Z",
    stroke: "#45C74D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 16.3C14.5428 17.2334 14.7609 18.9069 15.0439 20.5C15.0439 20.5 19.3223 17.5481 16.5856 13.5",
    stroke: "#45C74D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.69998 9.49987C4.76664 7.45709 3.09305 7.23899 1.5 6.95601C1.5 6.95601 4.45194 2.67753 8.5 5.41431",
    stroke: "#45C74D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.70864 13.4998C4.07675 14.1317 3.00253 15.9642 3.7608 18.239C6.03562 18.9973 7.86811 17.9231 8.49998 17.2912",
    stroke: "#45C74D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5952 7.253C16.5952 6.2328 15.7682 5.40578 14.748 5.40578C13.7278 5.40578 12.9008 6.2328 12.9008 7.253C12.9008 8.27319 13.7278 9.10022 14.748 9.10022C15.7682 9.10022 16.5952 8.27319 16.5952 7.253Z",
    stroke: "#45C74D",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartups);
export default __webpack_public_path__ + "static/media/Startups.f6c1c82b2610e4815d40c68f3d4cae00.svg";
export { ForwardRef as ReactComponent };